<script setup lang="ts">
import { computed } from '#imports';
import InlineSvg from 'vue-inline-svg';
import { getIconName, getIllustrationsName } from './iconNameTemplate';
import type { UiIconName, UiIllustrationName } from './IconName.ts';

interface IconTemplate {
  name?: string;
  size?: number;
  type?: 'icon' | 'illustration' | 'custom';
  colored?: boolean;
}

const props = withDefaults(defineProps<IconTemplate>(), {
  name: '',
  type: 'icon',
  colored: false,
});

const iconPath = computed(() => {
  switch (props.type) {
    case 'icon':
      return getIconName(props.name as UiIconName);
    case 'illustration':
      return getIllustrationsName(props.name as UiIllustrationName);
    default:
      return props.name;
  }
});
</script>

<template lang="pug">
InlineSvg.ui-icon-template(
  v-if="name"
  :src="iconPath"
  :data-qa="name"
  :width="size"
  :height="size"
  :class="{ 'ui-icon-template_full': [undefined, 0].includes(size), 'ui-icon-fill-color': type !== 'illustration' && !colored }"
)
</template>

<style lang="scss" scoped>
@import '../../styles/colors';

.ui-icon-template {
  flex-shrink: 0;
}

.ui-icon-template_full {
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
.ui-icon-fill-color path {
  fill: currentColor;
}
</style>
